import { useEffect, useState } from "react"
import { Suspense } from "react"
import { Outlet } from "react-router-dom"
import { Loader2 } from "lucide-react"
import { Sidebar } from "./Sidebar"
import { Header } from "./Header"
import { CommandPalette } from "./CommandPalette"
import { TooltipProvider } from "@/components/ui/tooltip"
import { SecureSendDialog } from "@/components/secure/SecureSendDialog"
import { useSecureShareStore } from "@/store/secureShareStore"

export function MainLayout() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false)
  const [paletteOpen, setPaletteOpen] = useState(false)
  const openSecureShare = useSecureShareStore((s) => s.openDialog)

  // Globale Hotkeys: Cmd/Ctrl+K (Palette) und Ctrl+Cmd+S bzw. Ctrl+Alt+S (Secure Share)
  useEffect(() => {
    function handler(e: KeyboardEvent) {
      const key = e.key.toLowerCase()
      if ((e.metaKey || e.ctrlKey) && key === "k") {
        e.preventDefault()
        setPaletteOpen((open) => !open)
        return
      }
      // Secure Share: macOS Ctrl+Cmd+S, sonst Ctrl+Alt+S
      if (key === "s" && ((e.metaKey && e.ctrlKey) || (e.ctrlKey && e.altKey))) {
        e.preventDefault()
        openSecureShare()
      }
    }
    window.addEventListener("keydown", handler)
    return () => window.removeEventListener("keydown", handler)
  }, [openSecureShare])

  return (
    <TooltipProvider>
      <div className="flex h-screen overflow-hidden bg-background">
        {/* Sidebar */}
        <Sidebar collapsed={sidebarCollapsed} onOpenPalette={() => setPaletteOpen(true)} />

        {/* Main Content */}
        <div className="flex flex-1 flex-col overflow-hidden">
          <Header
            onToggleSidebar={() => setSidebarCollapsed(!sidebarCollapsed)}
            onOpenPalette={() => setPaletteOpen(true)}
          />

          {/* Page Content */}
          <main className="flex-1 overflow-auto p-6">
            <Suspense fallback={<div className="flex items-center justify-center h-96"><Loader2 className="h-8 w-8 animate-spin text-muted-foreground" /></div>}>
              <Outlet />
            </Suspense>
          </main>
        </div>

        <CommandPalette open={paletteOpen} onOpenChange={setPaletteOpen} />
        <SecureSendDialog />
      </div>
    </TooltipProvider>
  )
}
